import React, { useContext } from "react"
import CKIcon from "@convertkit/design/ck-icon"
import { DiscoveryHubContext } from "./index"
import { Menu, MenuButton } from "@reach/menu-button"

export default function Button({ toggleDrawer }) {
  const context = useContext(DiscoveryHubContext)
  const countsClass = `
    inline-flex
    absolute
    -top-2
    -right-2
    justify-center
    items-center
    pl-1
    pr-1
    text-xs
    text-white
    bg-green-500
    rounded-full
  `

  const buttonClass = `
    main-link
    cursor-pointer
    p-1
    focus:bg-blue-600
    focus:bg-warm-white-200
    focus:no-underline
    focus:outline-none
    h-full
    hover:no-underline
    text-kit-black
    hover:text-white
    hover:text-kit-black
    items-center
    nav-hover
    relative
    rounded
  `

  const handleClick = event => {
    switch (event.keyCode) {
      case 13:
        event.preventDefault()
        toggleDrawer()
        break
    }
  }

  return (
    <Menu>
      <MenuButton
        onKeyDown={handleClick}
        onMouseDown={toggleDrawer}
        className={buttonClass}
      >
        {context.notificationCounter > 0 && (
          <div className={countsClass} style={{ top: "-7px", left: "14px" }}>
            {context.notificationCounter}
          </div>
        )}
        <CKIcon name="alarm" />
      </MenuButton>
    </Menu>
  )
}
